<template>
  <section class="px-4" @click="show_select = false">
    <section class="relative flex justify-between px-2 py-1 mt-2 bg-gray-100 rounded-md md:px-4 md:justify-center">
      <button class="z-10 h-full py-2 text-sm truncate duration-300 md:w-1/2 w-max"
        @click="(e) => handleChangeTab(e, '1')" :class="tab_active === '1' ? 'text-white' : ''" ref="first_tab">
        Employment Data
      </button>
      <button class="z-10 h-full py-2 text-sm truncate duration-300 md:w-1/2 w-max"
        @click="(e) => handleChangeTab(e, '2')" :class="tab_active === '2' ? 'text-white' : ''">
        Employment Attadance Day
      </button>
      <span class="absolute duration-300 -translate-y-1/2 rounded-md top-1/2 bg-primary"
        :style="`left:${indicator_position.left}px; height:${indicator_position.height}px;  width:${indicator_position.width}px;`" />
    </section>

    <section class="mt-4" v-if="tab_active === '1'">
      <Input label="Username" input_class="md:w-4/6 mt-2" class="mb-2.5" :value="data.username"
        @change="data.username = $event" />
      <SelectSearch :options="companies" property="company_name" label="Company" position="bottom"
        :selectedOption="data?.company_id" input_class="md:w-4/6 mt-2" :isOpen="show_select === 'company'"
        @handleShowSelect="show_select = 'company'" @selected="data.company_id = $event" />
      <Input label="NIK Karyawan" input_class="md:w-4/6 mt-2" class="mb-2.5" :value="data.emp_nik_karyawan"
        @change="data.emp_nik_karyawan = $event" />
      <SelectSearch :options="departement" property="dep_name" label="Departement" position="bottom"
        :selectedOption="data?.emp_depid" input_class="md:w-4/6 mt-2" :isOpen="show_select === 'departemen'"
        @handleShowSelect="show_select = 'departemen'" @selected="data.emp_depid = $event" />
      <SelectSearch :options="designation" property="des_name" :selectedOption="data?.emp_desid" label="Jabatan"
        position="bottom" input_class="md:w-4/6 mt-2" :isOpen="show_select === 'jabatan'"
        @handleShowSelect="show_select = 'jabatan'" @selected="data.emp_desid = $event" />
      <SelectSearch :options="empStatus" property="empstatus_name" :selectedOption="data?.emp_status"
        label="Status Karyawan" position="bottom" input_class="md:w-4/6 mt-2" :isOpen="show_select === 'status'"
        @handleShowSelect="show_select = 'status'" @selected="data.emp_status = $event" />
      <Select label="Tanggungan" input_class="md:w-4/6 mt-2" class="mb-2.5" :value="data?.emp_tanggungan"
        :options="['K', 'TK/0', 'TK/1', 'TK/2', 'TK/3', 'TK/4']" @change="data.emp_tanggungan = $event" />
      <SelectSearch :options="designation" label="HR Employment" property="des_name" @selected="data.emp_hr = $event"
        :selectedOption="data?.emp_hr" input_class="md:w-4/6 mt-2" position="top" :isOpen="show_select === 'hr'"
        @handleShowSelect="show_select = 'hr'" />
      <SelectSearch :options="designation" label="Atasan Pertama" property="des_name"
        @selected="data.emp_fsuperior = $event" :selectedOption="data?.emp_fsuperior" input_class="md:w-4/6 mt-2"
        position="top" :isOpen="show_select === 'atasan-1'" @handleShowSelect="show_select = 'atasan-1'" />
      <SelectSearch :options="designation" :selectedOption="data?.emp_ssuperior" @selected="data.emp_ssuperior = $event"
        property="des_name" label="Atasan Kedua" input_class="md:w-4/6 mt-2" position="top"
        :isOpen="show_select === 'atasan-2'" @handleShowSelect="show_select = 'atasan-2'" />
      <SelectSearch :options="locations" label="Lokasi Absensi" property="loc_name" @selected="data.emp_location = $event"
        :selectedOption="data?.emp_location" input_class="md:w-4/6 mt-2" position="top" :isOpen="show_select === 'lokasi'"
        @handleShowSelect="show_select = 'lokasi'" />
      <div class="flex justify-end w-full my-4">
        <Button class="w-24 py-2 text-sm text-white rounded bg-primary" @click="handleEditEmployement"
          :disabled="loading">
          Save
        </Button>
      </div>
    </section>
    <section class="mt-4" v-if="tab_active === '2'">
      <EmployementShift :emp_attadance="employment?.emp_attadance" :handleDetailEmployment="handleDetailEmployment" />
    </section>
  </section>
</template>

<script>
import Input from "./Input.vue";
import Button from "./Button.vue";
import Select from "./Select/index.vue";
import SelectSearch from "./Select/SelectSearch";
import { GetDepartementAPI } from "@/actions/departement";
import { GetDesignationAPI, GetRelDesAPI } from "@/actions/designation";
import { EditEmployementAPI } from "@/actions/employment";
import { GetAllCompanyEmployeeOptionsAPI } from "@/actions/company";
import { useToast } from "vue-toastification";
import { GetEmpStatusAPI } from "@/actions/emp-status";
import { GetLocationAPI } from "@/actions/location";
import EmployementShift from "./EmploymentShift.vue";

export default {
  name: "EmploymentData",
  props: { employment: Object, handleDetailEmployment: Function },
  components: { Input, Select, SelectSearch, Button, EmployementShift },
  data() {
    return {
      indicator_position: {
        left: 0,
        height: 0,
        width: 0,
      },
      loading: false,
      show_select: false,
      showModal: false,
      tab_active: "1",
      data: this.employment,
      companies: [],
      empStatus: [],
      departement: [],
      designation: [],
      locations: [],
    };
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  methods: {
    normalizeEmploymentData(employment) {
      const sourceEmployment = employment || this.employment || {};
      return {
        ...sourceEmployment,
        emp_depid: sourceEmployment?.emp_depid
          ? {
              dep_name: sourceEmployment?.emp_depid?.dep_name,
              _id: sourceEmployment?.emp_depid?._id,
            }
          : "",
        emp_desid: sourceEmployment?.emp_desid
          ? {
              des_name: sourceEmployment?.emp_desid?.des_name,
              _id: sourceEmployment?.emp_desid?._id,
            }
          : "",
        company_id:
          typeof sourceEmployment?.company_id === "string"
            ? this.companies.find((company) => company?._id === sourceEmployment?.company_id) ||
              null
            : sourceEmployment?.company_id || null,
      };
    },
    getSelectedCompanyId() {
      return this.data?.company_id?._id || this.data?.company_id || "";
    },
    handleChangeTab(event, tab) {
      const buttonHeight = event.target.offsetHeight;
      const buttonPosition = event.target.offsetLeft;
      const buttonWidth = event.target.offsetWidth;

      this.indicator_position.left = buttonPosition;
      this.indicator_position.width = buttonWidth;
      this.indicator_position.height = buttonHeight;
      this.tab_active = tab;
    },
    showMessageStatus(response) {
      if (response?.status === 200) {
        this.handleDetailEmployment();
        this.toast.success(response?.data?.message);
      } else {
        if (response?.data.message) {
          this.toast.error(response?.data?.message);
        }
      }
    },
    async handleGetDepartement() {
      const companyId = this.getSelectedCompanyId();
      if (!companyId) {
        this.departement = [];
        return;
      }
      const querySuperAdmin = `?company=${companyId}`;
      const response = await GetDepartementAPI(querySuperAdmin);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      this.departement = response?.data;
    },
    async handleGetDesignation() {
      const companyId = this.getSelectedCompanyId();
      if (!companyId) {
        this.designation = [];
        return;
      }
      const querySuperAdmin = `?company=${companyId}`;
      const response = await GetRelDesAPI(querySuperAdmin);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      this.designation = response?.data;
    },
    async handleGetLocation() {
      const companyId = this.getSelectedCompanyId();
      if (!companyId) {
        this.locations = [];
        return;
      }
      const querySuperAdmin = `?company_id=${companyId}`;
      const response = await GetLocationAPI(querySuperAdmin);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      this.locations = response?.data;
    },
    async getEmpStatus() {
      const companyId = this.getSelectedCompanyId();
      if (!companyId) {
        this.empStatus = [];
        return;
      }
      const queryAdminSuper = `?company_id=${companyId}`;
      const response = await GetEmpStatusAPI(queryAdminSuper);

      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      this.empStatus = response?.data;
    },
    async handleGetCompanies() {
      const response = await GetAllCompanyEmployeeOptionsAPI();
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      this.companies = response?.data || [];
      this.data = this.normalizeEmploymentData(this.employment);
    },
    async handleEditEmployement() {
      this.loading = true;
      const data = {
        ...this.data,
        company_id: this.getSelectedCompanyId(),
        emp_depid: this.data?.emp_depid?._id,
        emp_desid: this.data?.emp_desid?._id,
        emp_fsuperior: this.data?.emp_fsuperior?._id,
        emp_ssuperior: this.data?.emp_ssuperior?._id,
        emp_hr: this.data?.emp_hr?._id,
        emp_location: this.data?.emp_location?._id,
      };
      const { id } = this.$route.params;

      const response = await EditEmployementAPI(id, data);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      this.showMessageStatus(response);
      this.loading = false;
    },
  },
  watch: {
    employment: {
      handler(newData) {
        this.data = this.normalizeEmploymentData(newData);
        this.shift_day = newData?.emp_attadance;
      },
      deep: true,
    },
    "data.company_id": {
      async handler(newValue, oldValue) {
        const newCompanyId = newValue?._id || newValue || "";
        const oldCompanyId = oldValue?._id || oldValue || "";

        if (!newCompanyId || newCompanyId === oldCompanyId) {
          return;
        }

        await Promise.all([
          this.handleGetDepartement(),
          this.handleGetDesignation(),
          this.handleGetLocation(),
          this.getEmpStatus(),
        ]);
      },
      deep: true,
    },
  },
  async mounted() {
    await this.handleGetCompanies();
    this.handleGetDepartement();
    this.handleGetDesignation();
    this.handleGetLocation();
    this.getEmpStatus();
    const buttonHeight = this.$refs.first_tab?.offsetHeight;
    const buttonWidth = this.$refs.first_tab?.offsetWidth;
    const buttonPosition = this.$refs.first_tab?.offsetLeft;
    this.indicator_position.left = buttonPosition;
    this.indicator_position.height = buttonHeight;
    this.indicator_position.width = buttonWidth;
  },
};
</script>

<style scoped></style>
